<div class="form-group has-search inputField">
  <input [(ngModel)]="searchTerm" (ngModelChange)="search()" class="form-control form-control-search" placeholder="Suche"
    style="height: 38px;" />
  </div>
  @if (tabledata) {
    <div class="list-group list-scroll" [class.list-scroll-small]="!showDetails"
      [class.disable-list]="isTerminalLinkDisabled">
      <table mat-table [dataSource]="tabledata" class="table" multiTemplateDataRow
        matSort matSortDisableClear [trackBy]="trackByIndex">

        <ng-container matColumnDef="type" sticky>
          <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Typ</th>
          <td mat-cell *matCellDef="let terminal; let i = index" class="paddingLeft" [class.active]="isActive(terminal)">
            <span>{{terminal.deviceType}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="serialNumber" sticky>
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Seriennummer</th>
          <td mat-cell *matCellDef="let terminal; let i = index" [class.active]="isActive(terminal)">
            <span>{{terminal.serialNumber}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let terminal; let i = index" [class.active]="isActive(terminal)">
            <span>{{terminal.name}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="shop">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Betriebsstätte</th>
          <td mat-cell *matCellDef="let terminal; let i = index" [class.active]="isActive(terminal)">
            @if (terminal?.shop) {
              <span>{{terminal.shop.name}}</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="firmware">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Firmware Version</th>
          <td mat-cell *matCellDef="let terminal; let i = index" [class.active]="isActive(terminal)">
            <span>{{terminal.firmwareVersion}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;">Status</th>
          <td mat-cell *matCellDef="let terminal; let i = index">
            <status [status]="terminal.status"></status>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true" [class.no-display]="!showDetails"></tr>
        <tr mat-row *matRowDef="let terminal; columns: displayedColumns;" class="highlight clickable"
        (click)="isTerminalLinkDisabled ? selectTerminalFromList(terminal, $event) : openDetails(terminal, $event)"></tr>

      </table>
    </div>
  }
